import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { error } from 'console';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';

type AccountPublicRegisterBody = {
  cpf: string;
  cnpj: string;
  name: string;
  email: string;
  userCpf: string;
  userEmail: string;
  intendedPlanId?: number;
};

@Injectable({
  providedIn: 'root',
})
export class AccountPublicV2Service {
  url = `${environment.api_v2}/v2/account-public`;

  constructor(
    private readonly http: HttpClient,
    private readonly loginService: LoginService
  ) {}

  public register(body: AccountPublicRegisterBody): Observable<number> {
    return this.http.post<number>(`${this.url}/signup`, body).pipe(
      catchError((error) => {
        this.loginService.showMessage(error.error.message);
        return throwError(() => error);
      })
    );
  }
}
